import React from "react";

const Footer = () => {
  return (
    <div style={{ backgroundColor: "#030303" }} className="text-white py-5 m-0">
      <p>© Alim Imran. All Rights Reserved.</p>
    </div>
  );
};

export default Footer;
